import { apiService } from "../service/jobHistoryAllService";

export const FETCH_ATTENDANCE_REQUEST = "FETCH_ATTENDANCE_REQUEST";
export const FETCH_ATTENDANCE_SUCCESS = "FETCH_ATTENDANCE_SUCCESS";
export const FETCH_ATTENDANCE_FAILURE = "FETCH_ATTENDANCE_FAILURE";

export const FETCH_LOCATIONS_REQUEST = "FETCH_LOCATIONS_REQUEST";
export const FETCH_LOCATIONS_SUCCESS = "FETCH_LOCATIONS_SUCCESS";
export const FETCH_LOCATIONS_FAILURE = "FETCH_LOCATIONS_FAILURE";

// Fetch Attendance
export const fetchAttendance = (date, location) => async (dispatch) => {
  if (!date || !location) {
    console.error("Invalid date or location");
    return;
  }
  dispatch({ type: FETCH_ATTENDANCE_REQUEST });
  try {
    const data = await apiService.getGroupAttendanceAll(date, location);
    dispatch({ type: FETCH_ATTENDANCE_SUCCESS, payload: data.attendanceGroupList });
  } catch (error) {
    console.error("Error fetching attendance:", error.response?.data || error.message);
    dispatch({ type: FETCH_ATTENDANCE_FAILURE, error: error.message });
  }
};

// Fetch Locations
export const fetchLocations = (company) => async (dispatch) => {
  dispatch({ type: FETCH_LOCATIONS_REQUEST });
  try {
    const data = await apiService.getLocationsByCompany(company);
    dispatch({ type: FETCH_LOCATIONS_SUCCESS, payload: data.LocationList });
  } catch (error) {
    dispatch({ type: FETCH_LOCATIONS_FAILURE, error: error.message });
  }
};
